const DOMAIN_PATH_MAP: { [hostname: string]: string } = {
  'dev.toqqer.com': '/toqqer/static/toqqer-ui',
  'toqqer.com': '/ui',
  'www.toqqer.com': '/ui',
  // homecinemaplus.tv and localhost have no base path
};

export function getAppBasePath(): string {
  return DOMAIN_PATH_MAP[window.location.hostname] || '';
}
